import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import CoworkingPage from "./pages/CoworkingPage";
import EducationPage from "./pages/EducationPage";
import EducationVerifyPage from "./pages/EducationVerifyPage";
import ContactPage from "./pages/ContactPage";
import ImpressumPage from "./pages/ImpressumPage";
import AGBPage from "./pages/AGBPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import SeminarErfolgPage from "./pages/SeminarErfolgPage";
import AdminPage from "./pages/AdminPage";
import SeminarFlyerPage from "./pages/SeminarFlyerPage";
import SignatureFlyerPage from "./pages/SignatureFlyerPage";
import AppPage from "./pages/AppPage";
import CookieConsent from "./components/CookieConsent";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/coworking" element={<CoworkingPage />} />
          <Route path="/education" element={<EducationPage />} />
          <Route path="/education/verify" element={<EducationVerifyPage />} />
          <Route path="/events" element={<Navigate to="/education" replace />} />
          <Route path="/community" element={<Navigate to="/education" replace />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/agb" element={<AGBPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/seminar-erfolg" element={<SeminarErfolgPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/seminar-flyer" element={<SeminarFlyerPage />} />
          <Route path="/signature-flyer" element={<SignatureFlyerPage />} />
          <Route path="/app" element={<AppPage />} />
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
